<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="page-user-view">
  
      <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
        <span>User record with id: {{ $route.params.userId }} not found. </span>
        <span>
          <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
        </span>
      </vs-alert> -->
  
      <div id="user-data" >
        <!-- {{"Permissao adicionar "+canAddEmp}} -->
        <vx-card  class="mb-base" title="Filtros">
          <div class="vx-row">
            <div class="vx-col w-1/4  mb-5" >
    <label for="">Data de entrada</label>
           <vs-input
                  class="w-full"
                  icon-pack="feather"
                  icon-no-border
                  type="date"
                  v-validate="'required'"
                />
            </div>
            <div class="vx-col w-1/4  mb-5" >
              <label for="">Data de entrada</label>
                     <vs-input
                            class="w-full"
                            icon-pack="feather"
                            icon-no-border
                            type="date"
                            v-validate="'required'"
                          />
                      </div>
   <div class="vx-col w-1/5  mb-5" >
    <label for="">Observação</label>
           
           <select   class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" 
           >
      <option  value="presente">presente</option>
      <option  value="ausente">ausente</option>
      <option  value="antecipado">antecipado</option>
      <option  value="atrasado">atrasado</option>
      <option  value="folga">folga</option>
      <option  value="licença">licença</option>
    </select>
            </div>
         
             
             <div class="vx-col w-1/6  mb-5" >
               <label for=""></label> <br>
                  <vs-button class="w-full" type="border" color="warning" >Limpar</vs-button>
                
            </div>
            <!-- <div class="vx-col w-1/6  mb-5" >
               <label for=""></label> <br>
                <vs-button  class="w-full" color="primary"  @click="saveMarcar">
                  Marcar
                </vs-button>
                
            </div> -->
           
           
  
           
            </div>
          <!-- Avatar -->
          
  
        </vx-card>
  
     
   
         
      </div>

      <div>
        
      </div>

<div>
    <vue-apex-charts type="line" height="350" :options="lineChartSimple.chartOptions" :series="lineChartSimple.series"></vue-apex-charts>
</div>

    </div>
  </template>
  
  <script>
  import http from '../../../../http-common';
  import vSelect from 'vue-select'
  export default {
    data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      lineChartSimple: {
        series: [{
          name: "Desktops",
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
        }],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: themeColors,
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: 'Product Trends by Month',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
          }
        }
      }
    }
  }
   

  
  }
  
  </script>
  
  <style lang="scss">
  #avatar-col {
    width: 10rem;
  }
  
  #page-user-view {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .8rem;
        word-break: break-all;
      }
  
      &:not(.permissions-table) {
        td {
          @media screen and (max-width:370px) {
            display: block;
          }
        }
      }
    }
  }
  
  // #account-info-col-1 {
  //   // flex-grow: 1;
  //   width: 30rem !important;
  //   @media screen and (min-width:1200px) {
  //     & {
  //       flex-grow: unset !important;
  //     }
  //   }
  // }
  
  
  @media screen and (min-width:1201px) and (max-width:1211px),
  only screen and (min-width:636px) and (max-width:991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  
    // #account-manage-buttons {
    //   width: 12rem !important;
    //   flex-direction: column;
  
    //   > button {
    //     margin-right: 0 !important;
    //     margin-bottom: 1rem;
    //   }
    // }
  
  }
  
  </style>
  